import {
  fetch as fetchApi,
  insert as insertApi,
  drop as dropApi,
  isString,
} from "./api";
import { UserGroupCodec, UserGroup, Data } from "../store/usergroup/types";
import { withDecoded, flattenData } from "./";

function mapToModel(data: object): UserGroup {
  return withDecoded(UserGroupCodec, data, (decoded) => ({
    ...decoded,
  }));
}

export async function fetch(
  id?: string | null,
  params?: {}
): Promise<UserGroup> {
  return fetchApi({
    nestedResourcePath: ["usergroup"],
    id: id,
    params: params,
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function save(group: Data): Promise<UserGroup> {
  return insertApi({
    nestedResourcePath: ["usergroup"],
    id: group.id,
    data: { data: group },
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function drop(id: string | null): Promise<any> {
  return dropApi({
    nestedResourcePath: ["usergroup"],
    id: id,
  }).then((response) => response.data);
}
